import React from "react";
import Column from "components/ui/layout/column/column";
import CardBox from "components/ui/controls/card-box/card-box";
import Row from "components/ui/layout/row/row";

const DetailTrimestreRU = ({ InfosTrimestres }) => {
  let TotalTrimRU = 0;
  let TotalTrimAvpf = 0;
  let TotalTrimTrimSpe = 0;
  let TotalTrimMilitaire = 0;
  let TotalTrimChomage = 0;
  let TotalTrimInvalidite = 0;
  let TotalTrimMaladie = 0;
  let TotalTrimMaternite = 0;
  for (const annee in InfosTrimestres?.TabTrimestreRU) {
    if (InfosTrimestres?.TabTrimestreRU[annee].hasOwnProperty("RegimeUnifie")) {
      TotalTrimRU += InfosTrimestres?.TabTrimestreRU[annee]["RegimeUnifie"];
    }
    if (InfosTrimestres?.TabTrimestreRU[annee].hasOwnProperty("Avpf")) {
      TotalTrimAvpf += InfosTrimestres?.TabTrimestreRU[annee]["Avpf"];
    }
    if (InfosTrimestres?.TabTrimestreRU[annee].hasOwnProperty("TrimSpecifique")) {
      TotalTrimTrimSpe += InfosTrimestres?.TabTrimestreRU[annee]["TrimSpecifique"];
    }
    if (InfosTrimestres?.TabTrimestreRU[annee].hasOwnProperty("Militaire")) {
      TotalTrimMilitaire += InfosTrimestres?.TabTrimestreRU[annee]["Militaire"];
    }
    if (InfosTrimestres?.TabTrimestreRU[annee].hasOwnProperty("Chomage")) {
      TotalTrimChomage += InfosTrimestres?.TabTrimestreRU[annee]["Chomage"];
    }
    if (InfosTrimestres?.TabTrimestreRU[annee].hasOwnProperty("Invalidite")) {
      TotalTrimInvalidite += InfosTrimestres?.TabTrimestreRU[annee]["Invalidite"];
    }
    if (InfosTrimestres?.TabTrimestreRU[annee].hasOwnProperty("Maladie")) {
      TotalTrimMaladie += InfosTrimestres?.TabTrimestreRU[annee]["Maladie"];
    }
    if (InfosTrimestres?.TabTrimestreRU[annee].hasOwnProperty("Maternite")) {
      TotalTrimMaternite += InfosTrimestres?.TabTrimestreRU[annee]["Maternite"];
    }
  }  return (
    <Column fill>
      <CardBox>
        <Column fill>
          <Row>
            <div className="revenuspro-container">
              {/* Header séparé */}
              <div className="header-card">
                <div className="category-column" style={{ textAlign: "center", maxWidth: "120px" }}>Année</div>
                <div className="value-column" style={{ textAlign: "center" }}>Trim. cotisés</div>
                <div className="value-column" style={{ textAlign: "center" }}>Avpf</div>
                <div className="value-column" style={{ textAlign: "center" }}>Trim. spécifiques cotisés</div>
                <div className="value-column" style={{ textAlign: "center" }}>Militaire</div>
                <div className="value-column" style={{ textAlign: "center" }}>Chômage</div>
                <div className="value-column" style={{ textAlign: "center" }}>Maladie</div>
                <div className="value-column" style={{ textAlign: "center" }}>Maternité</div>
                <div className="value-column" style={{ textAlign: "center" }}>Invalidité</div>
              </div>

              {/* Conteneur des cartes de contenu */}
              <div className="card-list-container">
                {Object.entries(InfosTrimestres?.TabTrimestreRU).map((data, index) => {
                  return (
                    <div key={"DetailTrimestreRU" + index} className="card">
                      <div className="category-column" style={{maxWidth: "120px"}}>
                        <span className="trimester-year-badge">{data[0]}</span>
                      </div>
                      <div className="value-column">
                        {data[1].hasOwnProperty("RegimeUnifie") ? data[1]["RegimeUnifie"] : ""}
                      </div>
                      <div className="value-column">
                        {data[1].hasOwnProperty("Avpf") ? data[1]["Avpf"] : ""}
                      </div>
                      <div className="value-column">
                        {data[1].hasOwnProperty("TrimSpecifique") ? data[1]["TrimSpecifique"] : ""}
                      </div>
                      <div className="value-column">
                        {data[1].hasOwnProperty("Militaire") ? data[1]["Militaire"] : ""}
                      </div>
                      <div className="value-column">
                        {data[1].hasOwnProperty("Chomage") ? data[1]["Chomage"] : ""}
                      </div>
                      <div className="value-column">
                        {data[1].hasOwnProperty("Maladie") ? data[1]["Maladie"] : ""}
                      </div>
                      <div className="value-column">
                        {data[1].hasOwnProperty("Maternite") ? data[1]["Maternite"] : ""}
                      </div>
                      <div className="value-column">
                        {data[1].hasOwnProperty("Invalidite") ? data[1]["Invalidite"] : ""}
                      </div>
                    </div>
                  );
                })}
                
                {/* Carte récapitulative Total */}
                <div className="card" style={{ backgroundColor: "#f3f4f6", fontWeight: "600" }}>
                  <div className="category-column" style={{ fontWeight: "600", textAlign: "center", maxWidth: "120px" }}>
                    <span>Total</span>
                  </div>
                  <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                    {TotalTrimRU}
                  </div>
                  <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                    {TotalTrimAvpf}
                  </div>
                  <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                    {TotalTrimTrimSpe}
                  </div>
                  <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                    {TotalTrimMilitaire}
                  </div>
                  <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                    {TotalTrimChomage}
                  </div>
                  <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                    {TotalTrimMaladie}
                  </div>
                  <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                    {TotalTrimMaternite}
                  </div>
                  <div className="value-column" style={{ fontWeight: "600", textAlign: "center" }}>
                    {TotalTrimInvalidite}
                  </div>
                </div>
              </div>
            </div>
          </Row>
        </Column>
      </CardBox>
    </Column>
  );
};

export default DetailTrimestreRU;

//    <FormatLignePension
//   key={index++}
//   caisse={"RSI Commerçant"}
//   points={data[1]["General"]["TotalPoint"]}
//   valeurPoint={data[1]["General"]["ValeurPoint"]}
//   pensionTheo={data[1]["General"]["PensionTheorique"]}
//   coeff={data[1]["General"]["Coefficient"]}
//   majoEnfant={"-"}
//   pension={data[1]["General"]["Pension"]}
// />
